import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, Container, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const Addbusrouteassignment = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [editId, setEditId] = useState(null);
    const [buses, setBuses] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [attenders, setAttenders] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const routeLocation = useLocation();

    const [form, setForm] = useState({
        route_id: "",
        route_name: "",
        start_location: "",
        end_location: "",
        estimated_time: "",
        school_id: "",
        vehicle_id:"",
        driver_id:"",
        attendor_id:"",
        
    });

     useEffect(() => {
            fetchRoutes();
            vehicleData();
            DriverData();
            AttenderData();
        }, []);

     const fetchRoutes = async () => {
    const resp = await axios.get(`${baseUrl}/routes/${userObj.school_id}`, { params: { action: 'READ' } });
    setRoutes(resp.data || []);
  };

        const vehicleData = async () => {
            try {
                const response = await axios.post(baseUrl + "/vehicle/", {
                    action: "READ",
                    school_id: userObj.school_id
                });
    
                setBuses(response.data);
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };

        const DriverData = async () => {
            try {
                const response = await axios.get(baseUrl + "/driversintransport/", {
                    action: "READ",
                    school_id: userObj.school_id
                });
    
                setDrivers(response.data);
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };

        const AttenderData = async () => {
            try {
                const response = await axios.get(baseUrl + "/attenders-in-transport/", {
                    action: "READ",
                    school_id: userObj.school_id
                });
    
                setAttenders(response.data);
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };

    useEffect(() => {
        if (routeLocation.state?.routesData) {
            const routesData = routeLocation.state.routesData;
            setForm(routesData);
            setEditId(routesData.bus_route_id);
        }
    }, [routeLocation]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };

    const toHHMM = (raw) => {
        if (!raw) return null;
        const cleaned = raw.replace(".", ":");
        const m = /^(\d{1,2}):?(\d{2})$/.exec(
            cleaned.includes(":") ? cleaned : cleaned.replace(/\D/g, "")
        );
        if (!m) return null;
        let [, h, mm] = m;
        h = h.padStart(2, "0");
        if (+h > 99 || +mm > 59) return null;
        return `${h}:${mm}`;
    };

    

   const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare payload
    const payload = {
        bus_route_id: editId !== null ? editId : null,
        vehicle_id: Number(form.vehicle_id),
        route_id: Number(form.route_id),
        driver_id: Number(form.driver_id),
        attendor_id: Number(form.attendor_id),
        school_id: Number(userObj.school_id),
        action: editId !== null ? "UPDATE" : "CREATE",
        createdby: userObj.user_id,
        lastmodifiedby: userObj.user_id,
        is_active: "A",
    };

    try {
        // Send request
        const response = await axios.post(baseUrl + "/bus-route-assignment/", payload, {
            headers: { "Content-Type": "application/json" },
        });

        // Success toast
        if (editId !== null) {
            toast.success("Record updated successfully");
            setEditId(null);
        } else {
            toast.success("Record added successfully");
        }

        // Reset form
        setForm({
            route_id: "",
            route_name: "",
            start_location: "",
            driver_id:"",
            driver_name:"",
            attendor_id:"",
            attender_name:"",

            end_location: "",
            estimated_time: "",
            school_id: "",
            vehicle_id:"",
        });

    } catch (error) {
        // Error handling
        const status = error?.response?.status;
        const data = error?.response?.data;
        const msg = data?.error || data?.message || "Unexpected error occurred";

        if (status === 409) {
    if (msg.includes("Driver already has an active assignment")) {
        toast.error("Driver already has an active assignment in this school.");
    } else if (msg.includes("Attendor already has an active assignment")) {
        toast.error("Attendor already has an active assignment in this school.");
    } else {
        toast.error("Duplicate active assignment exists for the given vehicle, route, or school.");
    }
} else {
    toast.error(msg);
}
    }
};


    return (
        <div className='pageBody'>
            <ToastContainer />
            <Container fluid>
                <Card>
                    <Card.Body>
                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col xs={12}>
                                    <h6 className='commonSectionTitle'>Bus Route Assignment</h6>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6} lg={4} xxl={3}>
  <div className="commonInput">
    <Form.Group>
      <Form.Label>
        Vehicle Name <span className="requiredStar">*</span>
      </Form.Label>
      <Form.Select
        required
        id="vehicle_id"
        value={form.vehicle_id}
        onChange={handleInputChange}
      >
        <option value="" disabled hidden>Select Vehicle Name</option>
        {(buses || [])
          .filter((bus) => bus.status === "Active") // ✅ only active vehicles
          .map((bus) => (
            <option key={bus.vehicle_id} value={bus.vehicle_id}>
              {bus.model}
            </option>
          ))}
      </Form.Select>
    </Form.Group>
  </div>
</Col>

                                 <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                Route Name <span className="requiredStar">*</span>
                                            </Form.Label>
                                            <select
  className="form-select"
  required
  id="route_id"
  value={form.route_id}
  onChange={handleInputChange}
>
  <option value="" disabled hidden>Select Route Name</option>
  {(routes || [])
    .filter((route) => route.status === "Active") // or your actual active flag
    .map((route) => (
      <option key={route.route_id} value={route.route_id}>
        {route.route_name}
      </option>
    ))}
</select>

                                        </Form.Group>
                                    </div>
                                </Col>


                              

                                <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                 Driver Name <span className="requiredStar">*</span>
                                            </Form.Label>
                                            <select
                                                className="form-select"
                                                required
                                                id="driver_id"
                                                value={form.driver_id}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled hidden>Select Driver Name</option>
                                                {(drivers || [])
                                                    // .filter((driver) => driver.is_active === "Active")
                                                    .map((driver) => (
                                                        <option key={driver.emp_id} value={driver.emp_id}>
                                                            {driver.emp_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                Attender Name <span className="requiredStar">*</span>
                                            </Form.Label>
                                            <select
                                                className="form-select"
                                                required
                                                id="attendor_id"
                                                value={form.attendor_id}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled hidden>Select  Attender Name</option>
                                                {(attenders || [])
                                                    // .filter((attender) => attender.is_active === "Active")
                                                    .map((attender) => (
                                                        <option key={attender.emp_id} value={attender.emp_id}>
                                                            {attender.emp_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>




                            </Row>
                            <div className="d-flex justify-content-between mt-3">
                                <div>
                                    <Button
                                        type="button"
                                        variant="primary"
                                        className="btn-info clearBtn"
                                        onClick={() => setForm({
                                            route_name: "",
                                            driver_id:"",
                                            driver_name:"",
                                            attendor_id:"",
                                            attender_name:"",
                                            vehicle_id:"",
                                            model:"",
                                            route_id:"",


                                        })}
                                    >
                                        Reset
                                    </Button>
                                </div>
                                <div>
                                    <Button
                                        type="button"
                                        variant="primary"
                                        className="btn-danger secondaryBtn me-2"
                                        onClick={() => window.history.back()}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="btn-success primaryBtn"
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default Addbusrouteassignment;
